// IMPORTANT : don't use this directive on an ng-show! use ng-if instead
class SpinnerController {
    $onInit() {
        this.isMessageSrOnly = this.isMessageSrOnly !== undefined
            ? this.isMessageSrOnly
            : true;
    }
}

const spinnerComponentDefinition = {
    bindings: {
        message: '@',
        isMessageSrOnly: '<?',
        customSpinnerClass: '@',
    },
    controller: SpinnerController,
    template: require('./spinner.component.html').trim(),
};

module.exports = {
    SpinnerController,
    spinnerComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/olycommon/loading-spinner/spinner.component.js